import PurchaseOrderRepository from "./PurchaseOrderRepository";
import SupplierManagementRepository from "./SupplierManagementRepository";
import EntitiesReposotory from "./EntitiesRepository";
import DocumentsRepository from "./DocumentsRepository";

const repositories = {
  PurchaseOrder: PurchaseOrderRepository,
  Entities: EntitiesReposotory,
  Documents: DocumentsRepository,
  SupplierManagement: SupplierManagementRepository,

};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};

export default RepositoryFactory;
